<template>
  <div class="download-middle" v-loading="loading"></div>
</template>
<script>
import { getAppWebsiteInfoPort } from '@/api/downloadApp/index'

export default {
  data () {
    return {
      loading: false,
      formSetting: {
        logo: '',
        title: '',//标题
        mobile_background: '', //手机背景图
        pc_background: '', //PC背景图
        android_url: '', //android下载地址
        ios_url: '', //iOS下载地址
        domain_name: '',
        port: ""//端口
      },
    }
  },
  async created () {
    try {
      await this.getAppWebsiteInfo()
      const client = this.judgeClient()
      console.log('client', client)
      let url = ''
      switch (client) {
        case 'iOS':
          url = this.formSetting.ios_url
          break
        case 'Android':
          url = this.formSetting.android_url
          break
        default:
            url = ''
      }
      if(url) {
          console.log(url)
          window.location.href = url
          return 
      }
      this.$router.push({
          name: 'downloadPage'
      })
    } catch (error) {
      this.loading = false
    }
  },
  methods: {
    async getAppWebsiteInfo () {
      const {
        data: {
          result, status, msg
        }
      } = await getAppWebsiteInfoPort()
      if (status === 1000) {
        Object.assign(this.formSetting, result)
        console.log('lallalalal', result)
        return
      }
      return this.$message.error(msg)
    },
    judgeClient () {
      let client = '';
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {  //判断iPhone|iPad|iPod|iOS
        client = 'iOS';
      } else if (/(Android)/i.test(navigator.userAgent)) {  //判断Android
        client = 'Android';
      } else {
        client = 'PC';
      }
      return client;
    },
  }
}
</script>
<style lang="scss">
.download-middle {
  height: 100vh;
  width: 100%;
  overflow: hidden;
}
</style>